
export function generatePieColorList (length = 0) {
  const colorList = [{
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0,
      color: '#00B2FF' // 0% 处的颜色
    }, {
      offset: 1,
      color: '#0072FF' // 100% 处的颜色
    }]
  }, {
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0,
      color: '#a77dff' // 0% 处的颜色
    }, {
      offset: 1,
      color: '#f3d1ff' // 100% 处的颜色
    }]
  }, {
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0,
      color: 'rgb(254,104,157)' // 0% 处的颜色
    }, {
      offset: 1,
      color: 'rgb(247,10,81)' // 100% 处的颜色
    }]
  }, {
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [{
      offset: 0,
      color: '#00B4FF' // 0% 处的颜色
    }, {
      offset: 1,
      color: '#70eefe' // 100% 处的颜色
    }]
  }]
  if (length > colorList.length) {
    const minuLength = length - colorList.length
    for (let i = 0; i < minuLength; i++) {
      const start_color = MBRandomColor(getBrightHexColor())
      const end_color = MBRandomColor(start_color)
      colorList.push({
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: start_color // 0% 处的颜色
        }, {
          offset: 1,
          color: end_color // 100% 处的颜色
        }]
      })
    }
  }
  return colorList
}
// 生成比较亮的随机色
export function getBrightHexColor () {
  let r, g, b
  do {
    r = Math.floor(Math.random() * 128 + 127)
    g = Math.floor(Math.random() * 128 + 127)
    b = Math.floor(Math.random() * 128 + 127)
  } while (r === 255 && g === 255 && b === 255) // 排除纯白色
  const color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
  return color
}

// 根据基础颜色值 生成附近随机颜色
export function MBRandomColor (baseColor = 'white') {
    // 将hex颜色值转换为rgb数组
  let rgb = hexToRgb(baseColor)

    // 将rgb转为hsv格式
  let hsv = rgbToHsv(rgb[0], rgb[1], rgb[2])

    // 随机扰动hsv参数
  hsv[0] = (hsv[0] + Math.random() * 40 - 20 + 360) % 360// h
  hsv[1] = Math.min(1, Math.max(0, hsv[1] + Math.random() * 0.2 - 0.1))// s
  hsv[2] = Math.min(1, Math.max(0, hsv[2] + Math.random() * 0.4 - 0.2))// v
    // 将hsv转回rgb
  rgb = hsvToRgb(hsv)

    // 再转为16进制颜色
  return rgbToHex(rgb[0], rgb[1], rgb[2])
}

// 下面是颜色空间转换的工具函数
function hexToRgb (hex) {
    // 将#字符后面的部分转换为RGB值
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
}

/**
 * Converts an RGB color value to HSV. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and v in the set [0, 1].
 *
 * @param   Number  r       The red color value
 * @param   Number  g       The green color value
 * @param   Number  b       The blue color value
 * @return  Array           The HSV representation
 */
function rgbToHsv (r, g, b) {
  r = r / 255, g = g / 255, b = b / 255
  var max = Math.max(r, g, b), min = Math.min(r, g, b)
  var h, s, v = max
  var d = max - min
  s = max == 0 ? 0 : d / max
  if (max == min) {
    h = 0 // achromatic
  } else {
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break
      case g: h = (b - r) / d + 2; break
      case b: h = (r - g) / d + 4; break
    }
    h /= 6
  }
  return [h, s, v]
}
/**
 * Converts an HSV color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
 * Assumes h, s, and v are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   Number  h       The hue
 * @param   Number  s       The saturation
 * @param   Number  v       The value
 * @return  Array           The RGB representation
 */
function hsvToRgb (hsv) {
  let h = hsv[0]
  let s = hsv[1]
  let v = hsv[2]
  var r, g, b
  var i = Math.floor(h * 6)
  var f = h * 6 - i
  var p = v * (1 - s)
  var q = v * (1 - f * s)
  var t = v * (1 - (1 - f) * s)
  switch (i % 6) {
    case 0: r = v, g = t, b = p; break
    case 1: r = q, g = v, b = p; break
    case 2: r = p, g = v, b = t; break
    case 3: r = p, g = q, b = v; break
    case 4: r = t, g = p, b = v; break
    case 5: r = v, g = p, b = q; break
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)]
}

function rgbToHex (r, g, b) {
  var hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
  console.log('hex', hex)
  return '#' + hex
}
